import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SALES_TAX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the buyer's sales-tax line.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemSalesTaxMaybe = props => {
  const { lineItems, intl } = props;

  const taxLineItem = lineItems.find(item => item.code === LINE_ITEM_SALES_TAX && !item.reversal);

  return taxLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.salesTax" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, taxLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemSalesTaxMaybe;
